module.exports = __webpack_public_path__ + "img/activity-bg2.3fe171c3.png";